import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BadgeComponent } from '@sb/ui/badge';
import { IconComponent } from '@sb/ui/icon';
import { PlanQuotaModel, QuotaType } from '@shiftbase-com/ts-shared/models';

@Component({
  selector: 'app-quota-card-rule',
  imports: [IconComponent, TranslatePipe, BadgeComponent],
  templateUrl: './quota-card-rule.component.html',
})
export class QuotaCardRuleComponent {
  subscriptionPlanQuotas = input.required<Partial<Record<QuotaType, PlanQuotaModel>>>();

  quotaType = input.required<QuotaType.DEPARTMENTS | QuotaType.TEAMS | QuotaType.SEATS>();

  quotaTypes = QuotaType;
}
